import _                                 from 'underscore'
import React, { FC, lazy }               from 'react';
import { Link, Switch, Route, Redirect } from 'react-router-dom';

import { RouterUtility }                               from '../../../../util';
import { useSuspense }                                 from '../../../../hooks';
import { Flexbox, FlexItem, Page, PageTitleContainer } from '../../../containers';
import { SystemAccountingNav }                         from '../../../components/nav/SystemAccountingNav';
import { SystemAccountAdminsOnly }                     from '../../../components/util/access/RoleAccessControl';

const OrganizationsManager = lazy( () => import('./organizations/OrganizationsManager') );
const UserManager          = lazy( () => import('./users/UserManager') );

const routePaths = {
	home:          RouterUtility.getRoutePath( 'HOME' ) as string,
	adminIndex:    RouterUtility.getRoutePath( 'ADMIN' ) as string,
	organizations: RouterUtility.getRoutePath( 'ADMIN.SYSTEM_ACCOUNTING.ORGANIZATIONS' ) as string,
	users:         RouterUtility.getRoutePath( 'ADMIN.SYSTEM_ACCOUNTING.USERS' ) as string,
};

const SystemAccountingManagerPage: FC = () => {
	
	let { withSuspense } = useSuspense();
	
	return (
		<SystemAccountAdminsOnly redirect={ routePaths.home }>
			<Page name={ 'admin-user-accounting' }
			      padMainHorizontal={ false }
			      padMainVertical={ false }>
				
				<PageTitleContainer title={ 'Organization & User Management' } fluid={ true }/>
				
				<Flexbox className={ 'padding-xs-vertical padding-lg-horizontal container--colored-bg-teal' }>
					
					<FlexItem noGrow>
						
						<SystemAccountingNav secondary inverted color={ 'teal' }/>
					
					</FlexItem>
				
				</Flexbox>
				
				<Switch>
					<Route path={ routePaths.organizations } render={ withSuspense( OrganizationsManager ) }/>
					<Route path={ routePaths.users } render={ withSuspense( UserManager ) }/>
					<Redirect to={ routePaths.organizations }/>
				</Switch>
			
			</Page>
		</SystemAccountAdminsOnly>
	)
};

export default SystemAccountingManagerPage
